import React, { useState } from "react";
import {
  ModalComp,
  Scenario,
  Automation,
  DeviceOrg,
  Add,
  Profile,
} from "../../../shared";
import Carousel from "react-elastic-carousel";
import { AddItemsCard } from "../";
import "./style.css";
import { ScenariosOpt } from "./ScenariosOpt";
import { useTranslation } from "react-i18next";

const Options = ({ toggleOptions, toggle }) => {
  const { t } = useTranslation();
  const [openScenarioModal, setOpenScenarioModal] = useState(false);
  const [openAddAutomationModal, setOpenAddAutomationModal] = useState(false);
  const [openDeviceOrgModal, setOpenDeviceOrgModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  // const [openProfileModal, setOpenProfileModal] = useState(false);

  const toggleScenario = () => setOpenScenarioModal(!openScenarioModal);
  const toggleAddAutomation = () =>
    setOpenAddAutomationModal(!openAddAutomationModal);
  const toggleDeviceOrg = () => setOpenDeviceOrgModal(!openDeviceOrgModal);

  // const userInfo = useSelector(state => state.userProfileInfo);////
  // const toggleProfile = () => setOpenProfileModal(!openProfileModal);

  const toggleAdd = () => setOpenAddModal(!openAddModal);
  const breakPoints = [
    { width: 400, itemsToShow: 5 },
    { width: 550, itemsToShow: 9 },
  ];

  return (
    <>
      {/* <ModalComp
                modal={openProfileModal}
                toggle={toggleProfile}
                component={<Profile />}
                dark={true}
            /> */}

      <ModalComp
        modal={openScenarioModal}
        toggle={toggleScenario}
        component={<Scenario />}
        dark={true}
      />
      <ModalComp
        modal={openAddAutomationModal}
        toggle={toggleAddAutomation}
        component={<Automation />}
        dark={true}
      />
      <ModalComp
        modal={openDeviceOrgModal}
        toggle={toggleDeviceOrg}
        component={<DeviceOrg />}
        dark={true}
      />

      <ModalComp modal={openAddModal} toggle={toggleAdd} component={<Add />} />

      {/* <div className="my-3 position-relative" style={{ height: '41vh' }}> */}
      <div className="my-3 position-relative" style={{ height: "25vh" }}>
        <div className="options py-2 px-4 position-absolute w-100">
          <div className="d-flex justify-content-between align-items-center">
            <p className="m-0">{t("اضافه کردن")}</p>
            <i className="icon-cancel cursor" onClick={toggleOptions}></i>
          </div>
          <div className="mt-3 d-flex flex-wrap justify-content-between">
            <AddItemsCard
              toggle={toggleDeviceOrg}
              name={t("دستگاه")}
              count=""
            />
            <AddItemsCard toggle={toggleScenario} name={t("سناریو")} count="" />
            <AddItemsCard toggle={toggleAdd} name={t("اتاق")} count="" />
            <AddItemsCard
              toggle={toggleAddAutomation}
              name={t("اتوماسیون")}
              count=""
            />
            <AddItemsCard name={t("اعضا")} count="" />
            <AddItemsCard toggle={toggleAdd} name={t("ساختمان")} count="" />
          </div>
        </div>
        {/* <div className="d-flex text-center my-1 bg-white scenariosOpt position-absolute w-100">
                    <Carousel itemsToScroll={1} breakPoints={breakPoints}>
                        <ScenariosOpt name="خواب" />
                        <ScenariosOpt name="خواب" />
                        <ScenariosOpt name="در خانه" />
                        <ScenariosOpt name="موزیک" />
                        <ScenariosOpt name="بیرون خانه" />
                        <ScenariosOpt name="موزیک" />
                        <ScenariosOpt name="شب" />
                        <ScenariosOpt name="صبح" />
                        <ScenariosOpt name="خواب" />
                        <ScenariosOpt name="خواب" />
                        <ScenariosOpt name="خواب" />
                    </Carousel>
                </div> */}
      </div>
    </>
  );
};

export { Options };
